import { Directive, OnDestroy, AfterViewInit, OutputRefSubscription, inject, input } from '@angular/core';
import { AddToWatchlist } from '../domain';
import { ToastMessageService } from '../../../notifications-toast/toast-message/toast-message.service';

@Directive({
  selector: '[tdWbAddToWatchlistToastMessage]'
})
export class AddToWatchlistToastMessageDirective implements OnDestroy, AfterViewInit {
  private readonly addToWatchlistComponent = inject(AddToWatchlist);
  private readonly toastMessageService = inject(ToastMessageService);

  readonly messageKey = input<string>(undefined, { alias: 'tdWbAddToWatchlistToastMessage' });

  private updateSubscription: OutputRefSubscription;

  ngAfterViewInit(): void {
    this.updateSubscription = this.addToWatchlistComponent.symbolAdded
      .subscribe((): void => {
        this.toastMessageService.setToast(this.messageKey());
      });
  }

  ngOnDestroy(): void {
    this.updateSubscription?.unsubscribe();
  }
}
